import { render, staticRenderFns } from "./MgmIndicacao.vue?vue&type=template&id=5628b3fa&scoped=true"
import script from "./MgmIndicacao.vue?vue&type=script&lang=js"
export * from "./MgmIndicacao.vue?vue&type=script&lang=js"
import style0 from "./MgmIndicacao.vue?vue&type=style&index=0&id=5628b3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5628b3fa",
  null
  
)

export default component.exports